// extracted by css-extract-rspack-plugin
export default {"wrapper":"FileListPreview_wrapper__l1ZeR"};